module.exports = __webpack_public_path__ + "static/assets/610fb87d66b6749aeb96d475ceb62940.svg";